export default "__VITE_ASSET__CqNxfgWU__"